import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-create-document',
  templateUrl: './dialog-create-document.component.html',
  styleUrls: ['./dialog-create-document.component.css']
})
export class DialogCreateDocumentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
